<template>
  <user-scope-selector
    ref="selector"
    tip="选择部门"
    class="department-selector"
    :show-user-tab="false"
    :root-department="rootDepartment"
    :multiple="multiple"
    :value="localValue"
    @input="emitVal"
    :disabled="disabled"
    :clearable="clearable"
    :from="from"
    :include-sub="includeSub"
  ></user-scope-selector>
</template>

<script>
import UserScopeSelector from "@/components/UIComponents/UserScopeSelector"
import { getDepartmentTree } from "@/api/userCenter/company"
import { transTreeToArr } from "@/utils/user"

export default {
  name: "department-selector",
  components: { UserScopeSelector },
  props: {
    value: Array,
    disabled: Boolean,
    clearable: Boolean,
    multiple: Boolean,
    from: String,
    includeSub: Boolean
  },
  watch: {
    localValue: {
      handler(newVal, oldVal) {
        if (this._.isEqual(newVal, oldVal)) return
        this.initPromise.then(() => {
          this.$emit(
            "select",
            this.localValue.map(obj => this.departmentMap[obj.value])
          )
        })
      }
    }
  },
  computed: {
    localValue() {
      return (this.value || []).map(id => ({
        type: "department",
        value: id
      }))
    },
    departmentMap() {
      return this._.keyBy(transTreeToArr([this.rootDepartment]), "id")
    }
  },
  data() {
    return {
      rootDepartment: {},
      initPromise: null
    }
  },
  created() {
    this.initPromise = getDepartmentTree().then(
      departmentTree => (this.rootDepartment = departmentTree[0])
    )
  },
  methods: {
    emitVal(val) {
      this.$emit(
        "input",
        (val || []).map(obj => obj.value)
      )
      // emit change
      this.$emit(
        "change",
        val.map(obj => this.departmentMap[obj.value])
      )
    },
    focus() {
      this.$refs.selector.focus()
    }
  }
}
</script>

<style scoped></style>
